
import "./label_holder.css";
export function LabelHolder(props){
    return <div className="label_holder">
        {
            props.children
        }
    </div>
}